export default "__VITE_ASSET__DkrMCnCn__"